import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import TitleWidget from '../TitleWidget';

const StyledBoxApps = styled.div`
  background-color: ${props => props.theme.colors.light};
  width: 100%;

  ${mediaqueries.greaterThan('desktop')`
    height:auto;
  `};

  .atresmedia-publicidad {
    svg {
      position: relative;
      top: ${rem('12px')};
      width: ${rem('60px')};
    }
  }
`;

const StyledContentBoxApps = styled.div`
  align-content: flex-start;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
`;

const StyledBoxAppsDark = StyledBoxApps.extend`
  background-color: ${props => props.theme.colors.dark};
  height: 100%;

  ${mediaqueries.greaterThan('mobile')`
  .viewport {
    margin-right: ${rem('-100px')};
    padding-right: ${rem('100px')};
    max-height: ${rem('375px')};
    overflow-x: hidden;
    overflow-y-auto;
  }
  `};
`;

const StyledListApps = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.dark};
  display: flex;
  font-family: ${props => props.theme.fonts.medium};
  justify-content: center;
  margin-bottom: ${rem('35px')};
  min-height: ${rem('45px')};
  width: calc(100% / 3);

  &:hover {
    cursor: pointer;
  }

  ${mediaqueries.greaterThan('mobile')`
    margin-bottom: ${rem('30px')};
    margin: ${rem('25px')}
  `};

  ${mediaqueries.greaterThan('desktop')`
    width: calc(100% / 4);
    margin: ${props => (!props.show ? '0.5rem 2rem 2rem 0rem' : rem('8px'))}
  `};
`;

const StyledListAppsWidget = StyledListApps.extend`
  ${mediaqueries.between('mobile', 'desktop')`
    width: calc(100% / 5);
  `};
`;

const StyledSubtitle = styled(TitleWidget)`
  background-color: #c580b7;
`;

export {
  StyledBoxApps,
  StyledContentBoxApps,
  StyledBoxAppsDark,
  StyledListApps,
  StyledListAppsWidget,
  StyledSubtitle
};
